function hooplandiaLocal() {
  if ($('body').hasClass('hooplandiaHomepage')) {
    $('.content').append(`
          <div class="subpage-hoop-container">
          <div class="tier-one">
            <div id="slideshow-wrap" class="slideshow-wrap"></div>
            <div class="video-wrap"></div>
          </div>
          <div class="tier-two"></div>
          <div class="tier-three">
            <div id="inner-container"></div>
          </div>
          <div class="tier-four"></div>
          <div class="tier-five"></div>
          </div>
          `);
  } else {
    $('.content').append(`
          <div class="subpage-hoop-container">
          <div class="tier-five"></div>
          </div>
              `);
    $('#hoopMainSlideshow').remove();
    // $('#hoopVideoFeature').remove()
    $('#hooplandiaYoutubeVideo').remove();
    $('#hoopCards').remove();
    $('#hoopSEO').remove();
    $('#hoopTierFourCards').remove();
  }

  // HOOPLANDIA HOMEPAGE  SCRIPTS
  if ($('body').hasClass('hooplandiaHomepage')) {
    function onViewport(el, elClass, offset, callback) {
      var didScroll = true;
      var this_top;
      var height;
      var top;

      if (!offset) {
        var offset = 0;
      }

      $(window).scroll(function () {
        didScroll = true;
      });

      if (didScroll) {
        didScroll = false;
        top = $(this).scrollTop();

        $(el).each(function (i) {
          this_top = $(this).offset().top - offset;
          height = $(this).height();
          // Scrolled within current section
          if (top >= this_top && !$(this).hasClass(elClass)) {
            $(this).addClass(elClass);

            if (typeof callback == 'function') callback(el);
          }
        });
      }
    }

    $(window).scroll(function () {
      $('.animated').each(function (i) {
        onViewport(this, 'fadeInUp', 900, function () {});
      });
    });
  } else {
    $('#hoopFeatures').remove();
    $('#cardWidgetStats').remove();
  }

  // HOOPLANDIA SUBPAGE SCRIPTS
  $('.navDummyLink:contains("Hooplandia")').closest('.group').addClass('hooplandia-menu'); // Subpage Logo URL

  if ($('body').hasClass('hooplandiaTheme')) {
    // Sub Theme Favicon
    $('link[type="image/x-icon"]').attr(
      'href',
      `${FULLCLIENTTHEMEPATH}images/hooplandiaTheme/favicon.ico?sv=${SITEVERSION}`,
    );

    // Sub Theme Logo
    $('meta[property="og:image"]').attr(
      'content',
      `${FULLCLIENTTHEMEPATH}images/hooplandiaTheme/LogoFile1.png?sv=${SITEVERSION}`,
    );

    //HEADER-----------
    const hooplandiaHeaderMenu = `
        <div class="hop-top-bar">
        <div class="inner-container"> 
        <div id="hoopHeaderButton"></div>
        <div class="hop-search"></div>
        </div>
        </div>
        <div class="hop-bottom-bar">
        <div class="inner-container">
        <div class="hop-logo">
        <div class="hop-countdown"></div>
        </div>
        <div class="hop-nav"></div>
        <div class="hop-mob-countdown"></div>
        </div>
        </div>`;

    $('#hooplandia-container').append(hooplandiaHeaderMenu);

    $(window).load(function () {
      $('.hooplandia-footer .emailSignupbtn-container').appendTo('.hooplandia-footer .sign-up-container');
     // $('.hooplandia-footer .sign-up-container .emailSignupText').text('sign up FOR hooplandia’s latest updates',);
    //  $('.hooplandia-footer .sign-up-container .emailSubmitButton').addClass('button');
    //  $('.hooplandia-footer .sign-up-container .emailSubmitButton').text('subscribe');
    //  $('.hooplandia-footer .emailInputField input').attr('placeholder', 'Email Address:');
    //  $('.hooplandia-footer .emailInputField input').val('');
    });

    $('.header-logo').appendTo('#hooplandia-container .hop-logo');
    $('.hop-logo .header-logo').attr('href', `${SITEBASEURL}p/hooplandia`);
    // $('.header #siteInfoBannerWidget').appendTo('#hooplandia-container .hop-countdown')
    $('.header #mainNavigation').appendTo('#hooplandia-container .hop-nav');
    $('.header .searchBox').appendTo('#hooplandia-container .hop-search');
    $('.header .mobile-nav-toggle').insertAfter('#hooplandia-container .hop-search');
    $('.header-bottom').remove();
    $('.header-top').remove();

    // NAV ITEMS

    // FOOTER-----------

    const hooplandiaFooterOLd = `
    <div class="inner-container-top">
      <a href="/" class="footer-logo"></a>
      <div class="contact-us"></div>
      <div class="site-map"></div>
      <div class="sign-up-container"></div>
    </div>
    <div class="hoop-bottom-container">
      <div class="inner-container-bottom">
        <div class="copy-powered"></div>
        <div class="social-container"></div>
      </div>
    </div>
    `;
    const hooplandiaFooter = `
    <div class="inner-container-top">
      <a href="/" class="footer-logo"></a>
      <div class="contact-us"></div>
      <div class="site-map"></div>
      <div class="sign-up-container"></div>
    </div>
    <div class="social-container"></div>
    `;

    $('.hooplandia-footer').append(hooplandiaFooter);
    $('.hoop-info').appendTo('.contact-us');
    $('.footer').addClass('hooplandia-footer-container')
    $('.footer .footer-bige .footerItems1').appendTo('.hooplandia-footer .site-map');
    // $('.site-copyright').appendTo('.hooplandia-footer .copy-powered');
    // $('.powered-by-saffire').appendTo('.hooplandia-footer .copy-powered');

    let copyContent = $('.site-copyright span').text();
    let copyEdit = copyContent.split(/[,.]/);
    $('.site-copyright').text(``);
    $('.site-copyright').append(
      `<span>${copyEdit[0]}, Hooplandia. </span><span>${copyEdit[2]}</span>`,
    );

    $('.footer-logo').attr('href', `${SITEBASEURL}p/hooplandia`);

    $('.socialNetworks').remove();
    $('.footer-bige').remove();
    $('#sponsorWidgetContainer').remove();

    let footerLinks = [];

    // Hooplandia  Footer navigation
    $('.groups .group.hooplandia-menu .items > li:not(.subitems) > a').each(function () {
      let linK = $(this).attr('href');
      let name = $(this).text();

      if (name.toLowerCase() == 'hooplandia') {
        name = 'Home';
      }

      if (name.trim() !== '') {
        footerLinks.push({
          name: name,
          url: linK,
        });
      }
    });
    for (let i = 0; i < footerLinks.length - 1; i++) {
      let itname = footerLinks[i].name;
      let iturl = footerLinks[i].url;
      let navigationItem = `<li class="theme-nav"><a href="${iturl}">${itname}</a></li>`;
      $('.footerItems1').before(navigationItem);
    }
  } else {
    $('.hooplandia-footer').remove();
    $('#hoopSponsors').remove();
    $('#hoopQuickLinks').remove();
  }
}

export { hooplandiaLocal };
